(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PersonaController', PersonaController);

    PersonaController.$inject = ['Persona'];

    function PersonaController(Persona) {

        var vm = this;

        vm.personas = [];

        loadAll();

        function loadAll() {
            Persona.query(function(result) {
                vm.personas = result;
                vm.searchQuery = null;
            });
        }
    }
})();
